import React, { useEffect } from 'react';
import '../styles/AboutPage.css';

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/919024000691?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/919024000691?text=${encodedMessage}`;

  return (
    <div className="about-page">
      <header className="about-header text-center">
        <h1><span className='highlight'>About</span> Us</h1>
      </header>

      <main className="about-content">
        <div className="about-intro">
          <h2>Welcome to Reddy Anna Book – Your Gateway to Excellence:</h2>
          <p>
            Since 2010, Reddy Anna Book has been a trailblazer in cricket betting and trading, proudly serving as one of the most trusted platforms in the industry. As the largest book exchange for cricket betting after Mahadev’s Book, we stand out with seamless deposit and withdrawal processes. Operated exclusively by Reddy Anna, we connect with our users directly via WhatsApp for personalized support.
          </p>
          <p>
            Our platform has revolutionized the way users engage in online betting, introducing efficient methods to earn and offering instant cricket IDs with round-the-clock withdrawal services. With over 50,000 satisfied users and 200 offline branches, Reddy Anna Book leads the market with innovation and trust.
          </p>
        </div>

        <div className="about-who-we-are">
          <h2>Who We Are:</h2>
          <p>
            Reddy Anna Book is a pioneering force in online gaming, designed for enthusiasts seeking a thrilling and rewarding experience. Our vision is to reshape India’s gaming landscape by offering a trusted, skill-driven platform that blends entertainment with opportunity.
          </p>
        </div>

        <div className="about-trust">
          <h2>Built on Trust:</h2>
          <p>
            Trust is the foundation of Reddy Anna Book. We ensure every user enjoys secure and transparent transactions, regardless of the amount. With unwavering reliability and a strong commitment to user safety, we’ve created a platform that you can count on for a worry-free gaming experience.
          </p>
        </div>

        <div className="about-variety">
          <h2>Diverse Gaming Experiences:</h2>
          <p>
            At Reddy Anna Book, we celebrate the diversity of gaming preferences by offering a wide range of options. From live sports betting to traditional Indian card games, our platform caters to every enthusiast. Whether it’s Cricket, Kabaddi, Football, Tennis, or live dealer games, there’s something here for everyone.
          </p>
        </div>

        <div className="about-innovation">
          <h2>Innovation Redefined:</h2>
          <p>
            Our platform thrives on innovation, ensuring an exceptional gaming experience through cutting-edge technology. From quick and easy registration to our efficient 24-hour withdrawal service, we are committed to making your journey smooth, convenient, and enjoyable.
          </p>
        </div>

        <div className="about-portfolio">
          <h2>Explore Our Portfolio:</h2>
          <p>
            Dive into a rich collection of games that range from the traditional charm of Teen Patti to sophisticated live dealer options like Baccarat and Roulette. At Reddy Anna Book, we go beyond gaming to offer a comprehensive entertainment experience tailored to your preferences.
          </p>
        </div>

        <div className="about-join">
          <h2>Be Part of the Reddy Anna Book Family:</h2>
          <p>
            Joining Reddy Anna Book means becoming part of a community that celebrates your achievements, big or small. Our dedicated support team, available via Live Chat, Telegram, Facebook, and more, ensures you have guidance at every step of your journey.
          </p>
        </div>

        <div className="about-why-choose">
          <h2>Why Choose Reddy Anna Book?</h2>
          <ul>
            <li><strong>Reliability:</strong> Your trust is our top priority, with secure and transparent transactions at every step.</li>
            <li><strong>Diverse Options:</strong> From sports betting to live dealer games, we offer something for everyone.</li>
            <li><strong>Cutting-Edge Technology:</strong> Our platform is powered by the latest innovations for a seamless experience.</li>
            <li><strong>Convenience:</strong> Enjoy easy navigation, secure payment options, and 24-hour withdrawals.</li>
          </ul>
          <p>
            Discover the ultimate gaming experience with Reddy Anna Book. Visit <a href="/">www.reddyannaaid.org</a> today and embark on a thrilling journey where tradition meets modern innovation. Reddy Anna Book – Turning Every Game into an Adventure!
          </p>
        </div>

        <div className="abt-btn">
          <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Contact Us @ 6666856666
          </a>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            WhatsApp Us @ 6666066663
          </a>
        </div>
      </main>
    </div>
  );
};

export default AboutUs;
